import { FormContextProvider } from './FormContext';

const withForm = Component => {
	return props => {
		return (
			<FormContextProvider>
				<Component {...props} />
			</FormContextProvider>
		);
	};
};

export default withForm;
